import {Breadcrumbs, CachedTabs, useTab} from '@management-ui/core';
import {AssignmentReturned, Cached, CheckBox, PointOfSale, RecentActors} from '@mui/icons-material';
import * as React from 'react';
import routes from '../../../routes';
import Contacts from './Contacts/Table';
import Materials from './Materials/Table';
import PurchaseOrders from './PurchaseOrders/Table';
import SalesOrders from './SalesOrders/Table';
import Tasks from './Tasks/Table';

const TABS = [
  {
    id: 'contacts',
    slug: 'contacts',
    title: 'Contacts',
    icon: <RecentActors/>,
    render: (props) => <Contacts {...props} archive={true}/>
  },
  {
    id: 'purchaseOrders',
    slug: 'purchase-orders',
    title: 'Purchase Orders',
    icon: <AssignmentReturned/>,
    render: (props) => <PurchaseOrders {...props} archive={true}/>
  },
  {
    id: 'salesOrders',
    slug: 'sales-orders',
    title: 'Sales Orders',
    icon: <PointOfSale/>,
    render: (props) => <SalesOrders {...props} archive={true}/>
  },
  {
    id: 'materials',
    slug: 'materials',
    title: 'Materials',
    icon: <Cached/>,
    render: (props) => <Materials {...props} archive={true}/>
  },
  {
    id: 'tasks',
    slug: 'tasks',
    title: 'Tasks',
    icon: <CheckBox/>,
    render: (props) => <Tasks {...props} archive={true}/>
  },
];

const Archive = () => {
  const {tab, handleTab} = useTab(TABS, routes.archive.index);
  return (
    <div>
      <Breadcrumbs crumbs={[{title: 'Archive'}, {title: TABS.find(t => t.id === tab).title}]}/>
      <CachedTabs tab={tab} onChange={handleTab} tabs={TABS}/>
    </div>
  );
};

export default Archive;
